/**
 * SHARED CONSTANTS
 */
export default {
  DOMAIN: 'https://nirvana.imageslicer.com',
  CHOP_CHOP: 'chop-chop',
  // Canonical public deep-link route for viewing a saved slice.
  // Back-compat: older links used `/slice/:id` and the frontend redirects to this.
  SLICE_PAGE_PATH_PREFIX: '/s',
  // Thumbnail size (used for My Slices list previews).
  THUMB_PX: 56,
  // Auth password policy (shared by front + back).
  AUTH_PASSWORD_MIN_LEN: 8,
  AUTH_PASSWORD_MAX_LEN: 200
};
